import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../../translations';

export const TrustedDevicesEmptyStatePlaceholder = (): JSX.Element => {
   return (
      <EmptyStatePlaceholder
         testId={'noDevices'}
         heading={mfaSettingsTranslationKeys.trustedDeviceTable.noDevicesAdded}
         subheading={mfaSettingsTranslationKeys.trustedDeviceTable.addTrustedDeviceDuringLogIn}
      />
   );
};
